import { buildDeserializer } from "lib/serializerUtils";

const nlisProgramSerializeMap = {
  code: "code",
  status: "status",
};

const saleLotDetailSerializeMap = {
  saleLotId: "sale_lot_id",
  lotNumber: "lot_number",
  subLotNumber: "sub_lot_number",
  buyerId: "buyer_id",
  buyerName: "buyer_name",
  destinationPic: "destination_pic",
  vendorId: "vendor_id",
  vendorName: "vendor_name",
  vendorPic: "vendor_pic",
  auctionPenName: "auction_pen_name",
  agencyId: "agency_id",
  agencyName: "agency_name",
  saleyardId: "saleyard_id",
  saleyardName: "saleyard_name",
  saleDate: "sale_date",
  nlisPrograms: nlisProgramSerializeMap,
};

// Covers both EIDReportScanMine and EIDReportScanOther fields.
const scanSerializeMap = {
  isMine: "is_mine",
  // Mine fields
  id: "id",
  eid: "EID",
  livestockSaleId: "livestock_sale_id",
  deploymentId: "deployment_id",
  saleLotId: "sale_lot_id",
  euStatus: "EU_status",
  erpStatus: "ERP_status",
  lifetimeTraceability: "lifetime_traceability",
  currentPic: "current_pic",
  isNlisSighted: "is_nlis_sighted",
  nlisTakeStatus: "nlis_take_status",
  nlisSellStatus: "nlis_sell_status",
  nlisP2pStatus: "nlis_p2p_status",
  totalMassGrams: "total_mass_grams",
  created: "created",
  lastModified: "last_modified",
  saleLotDetail: saleLotDetailSerializeMap,
  // Other fields
  saleyardName: "saleyard_name",
  saleDate: "sale_date",
  agencyName: "agency_name",
};

const transferDetailSerializeMap = {
  responseType: "response_type",
  messageNo: "message_no",
  action: "action",
  sourcePic: "source_pic",
  destinationPic: "destination_pic",
};

const nlisTransferSerializeMap = {
  fileType: "file_type",
  fileId: "file_id",
  fileStatus: "file_status",
  created: "created",
  submitted: "submitted",
  processed: "processed",
  saleDate: "sale_date",
  isManualTransfer: "is_manual_transfer",
  errorNotes: "error_notes",
  transactionId: "transaction_id",
  submittedByFirstName: "submitted_by_first_name",
  submittedByLastName: "submitted_by_last_name",
  saleyardName: "saleyard_name",
  transferDetail: transferDetailSerializeMap,
};

const eidReportSerializeMap = {
  eid: "eid",
  nlisId: "nlis_id",
  isStaff: "is_staff",
  scans: scanSerializeMap,
  nlisTransfers: nlisTransferSerializeMap,
};

// Maps snake_case API keys that require renaming before nested-map lookup.
const nestedObjectMap = {
  nlis_transfers: "nlisTransfers",
  sale_lot_detail: "saleLotDetail",
  transfer_detail: "transferDetail",
  nlis_programs: "nlisPrograms",
};

const deserializeRaw = buildDeserializer(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  eidReportSerializeMap as any,
  "eidReport",
  nestedObjectMap,
);

export function deserializeEIDReport(raw: Record<string, unknown>): EIDReport {
  const deserialized = deserializeRaw(raw) as EIDReport;
  return {
    ...deserialized,
    id: deserialized.eid,
  };
}
